import React, { useEffect } from 'react'
import { HiX, HiCheckCircle, HiExclamationCircle, HiInformationCircle, HiBell } from 'react-icons/hi'

const Toast = ({ id, type = 'info', title, message, duration = 5000, onClose }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose(id)
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [duration, id, onClose])

  const types = {
    success: {
      bg: 'bg-success-soft',
      border: 'border-green-500',
      icon: <HiCheckCircle className="w-6 h-6 text-green-500" />,
      titleColor: 'text-green-900',
      messageColor: 'text-success'
    },
    error: {
      bg: 'bg-danger-soft',
      border: 'border-red-500',
      icon: <HiExclamationCircle className="w-6 h-6 text-red-500" />,
      titleColor: 'text-red-900',
      messageColor: 'text-danger'
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-500',
      icon: <HiExclamationCircle className="w-6 h-6 text-yellow-500" />,
      titleColor: 'text-yellow-900',
      messageColor: 'text-yellow-700'
    },
    info: {
      bg: 'bg-info-soft',
      border: 'border-brand',
      icon: <HiInformationCircle className="w-6 h-6 text-blue-500" />,
      titleColor: 'text-blue-900',
      messageColor: 'text-brand'
    },
    notification: {
      bg: 'bg-brand-soft',
      border: 'border-brand',
      icon: <HiBell className="w-6 h-6 text-brand" />,
      titleColor: 'text-brand',
      messageColor: 'text-brand'
    },
    broadcast: {
      bg: 'bg-gradient-to-r from-orange-50 to-yellow-50',
      border: 'border-orange-500',
      icon: <span className="text-2xl">📢</span>,
      titleColor: 'text-orange-900',
      messageColor: 'text-warning'
    }
  }

  const config = types[type] || types.info

  return (
    <div
      className={`${config.bg} border-l-4 ${config.border} rounded-lg shadow-lg p-4 mb-3 animate-slide-in-right max-w-md w-full backdrop-blur-sm`}
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">
          {config.icon}
        </div>
        <div className="flex-1 min-w-0">
          {title && (
            <h4 className={`font-semibold text-sm ${config.titleColor} mb-1`}>
              {title}
            </h4>
          )}
          <p className={`text-sm ${config.messageColor}`}>
            {message}
          </p>
        </div>
        <button
          onClick={() => onClose(id)}
          className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <HiX className="w-5 h-5" />
        </button>
      </div>
    </div>
  )
}

export default Toast

